module.exports = __webpack_public_path__ + "img/mail.d1234ece.svg";